import gql from 'graphql-tag';

export const getClosedShiftTurnoverNotes = gql`
  query getClosedShiftTurnoverNotes($shiftTurnoverId: String) {
    getClosedShiftTurnoverNotes(shiftTurnoverId: $shiftTurnoverId) {
      category
      AORId
      AORName
      addToTurnover
      abnormalOperation
      city
      contactId
      contactName
      createdAt
      county
      createdBy
      facilityName
      facilityId
      facilityUID
      falseAlarm
      id
      maop
      noteType
      phoneNumber
      pipeline
      pipelineSection
      state
      township
      updatedAt
      updater
      systemName
      entries {
        createdAt
        createdBy
        id
        note
        time
        updatedAt
        updater
        version
      }
    }
  }
`;
